import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EAsyncStatus, GreenroomState } from '../../../stores/types/types';
import { setModalOpen } from '../../../stores/actions/modal';
import { DeleteMeeting } from '../../../connection/meeting';
import WaitingIndicator from '../../general-components/waiting-indicator';
import { loadMeetingsStandaloneGreenroomProducer } from '../../../stores/actions/content';
import { deleteAccountAPI } from '../../../connection/auth';
import { logOut } from '../../../utils/utils';
import { setAccountDeleted } from '../../../stores/actions/session';

export default function DeleteAccount() {
	const dispatch = useDispatch();
	const token = useSelector((state: GreenroomState) => state.SessionReducer.token);
	const host = useSelector((state: GreenroomState) => state.SessionReducer.host);
	const user = useSelector((state: GreenroomState) => state.SessionReducer.user);

	const [status, setStatus] = useState(EAsyncStatus.Incomplete);

	const closeModal = () => {
		dispatch(setModalOpen(false));
	};

	const deleteAccount = async () => {
		if (token && user) {
			setStatus(EAsyncStatus.Waiting);

			const deleted = await deleteAccountAPI(token);

			if (deleted) {
				setStatus(EAsyncStatus.Complete);
				logOut(host, true);
				dispatch(setAccountDeleted(true));
				closeModal();
			}
		}
	};

	return (
		<div className="info-modal confirmation-dialog delete-event" data-testid="delete-account-modal">
			<h4>Are you sure you want to delete your account?</h4>
			<div className="text-content">All your info will be removed.</div>
			<div className="button-group">
				<button
					className="green"
					onClick={closeModal}
				>
					Cancel
				</button>
				<button
					className="gray"
					onClick={deleteAccount}
					data-testid="delete-account-btn"
				>
					{status === EAsyncStatus.Waiting ? (
						<WaitingIndicator />
					) : (
						<span>Delete</span>
					)}
				</button>
			</div>
		</div>
	);
}
